import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoDataFoundDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 188 132",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M151.972 0H39.6862C34.5184 0 30.3291 4.18934 30.3291 9.35714V121.643C30.3291 126.811 34.5184 131 39.6862 131H151.972C157.14 131 161.329 126.811 161.329 121.643V9.35714C161.329 4.18934 157.14 0 151.972 0Z",
			fill: "#1C494F"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_590_55746)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M137 9.35693H10.6786C8.09467 9.35693 6 11.4516 6 14.0355V37.4284C6 40.0123 8.09467 42.1069 10.6786 42.1069H137C139.584 42.1069 141.679 40.0123 141.679 37.4284V14.0355C141.679 11.4516 139.584 9.35693 137 9.35693Z",
				fill: "#0C5661"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.5634 16.8435H46.2349C44.6845 16.8435 43.4277 18.1003 43.4277 19.6506C43.4277 21.201 44.6845 22.4578 46.2349 22.4578H70.5634C72.1138 22.4578 73.3706 21.201 73.3706 19.6506C73.3706 18.1003 72.1138 16.8435 70.5634 16.8435Z",
			fill: "#779598"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4063 29.0083H46.2349C44.6845 29.0083 43.4277 30.2651 43.4277 31.8154C43.4277 33.3658 44.6845 34.6226 46.2349 34.6226H87.4063C88.9567 34.6226 90.2135 33.3658 90.2135 31.8154C90.2135 30.2651 88.9567 29.0083 87.4063 29.0083Z",
			fill: "#97B6B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.2648 12.1643H13.4862C10.9023 12.1643 8.80762 14.259 8.80762 16.8429V34.6215C8.80762 37.2054 10.9023 39.3 13.4862 39.3H31.2648C33.8487 39.3 35.9433 37.2054 35.9433 34.6215V16.8429C35.9433 14.259 33.8487 12.1643 31.2648 12.1643Z",
			fill: "#1C6974"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2427 28.8013H22.1141L22.1347 28.0808C22.1347 27.1338 22.7317 26.8868 23.5757 26.6192C24.4224 26.3784 25.1676 25.8684 25.6987 25.1665C26.2298 24.4645 26.5179 23.6087 26.5195 22.7285C26.538 22.1911 26.4448 21.6556 26.2457 21.1561C26.0466 20.6566 25.746 20.2038 25.3628 19.8265C24.9797 19.4492 24.5224 19.1555 24.0199 18.964C23.5174 18.7726 22.9806 18.6875 22.4435 18.7143C21.8759 18.7019 21.3117 18.805 20.7852 19.0172C20.2586 19.2294 19.7806 19.5464 19.3802 19.9489C18.9798 20.3513 18.6654 20.831 18.4559 21.3586C18.2464 21.8863 18.1463 22.451 18.1617 23.0186H20.0967C20.0894 22.7052 20.1447 22.3935 20.2593 22.1018C20.374 21.8101 20.5457 21.5442 20.7644 21.3197C20.9832 21.0952 21.2445 20.9167 21.5332 20.7945C21.8218 20.6723 22.1319 20.609 22.4454 20.6082C22.728 20.5918 23.0109 20.6364 23.2748 20.7391C23.5386 20.8418 23.7773 21 23.9746 21.2031C24.1718 21.4063 24.323 21.6495 24.4179 21.9162C24.5128 22.183 24.5492 22.467 24.5245 22.7491C24.5121 23.2056 24.3533 23.6461 24.0717 24.0056C23.79 24.365 23.4003 24.6246 22.96 24.7459L22.2807 25.0154C21.6156 25.1756 21.0349 25.5798 20.6537 26.1479C20.2725 26.7159 20.1184 27.4064 20.2221 28.0827L20.2427 28.8013ZM21.1691 33.2497C21.3523 33.2562 21.535 33.2259 21.7064 33.1606C21.8777 33.0953 22.0342 32.9962 22.1666 32.8694C22.2991 32.7426 22.4047 32.5905 22.4773 32.4221C22.55 32.2537 22.5881 32.0725 22.5895 31.8891C22.5879 31.7059 22.5495 31.5249 22.4768 31.3568C22.4041 31.1886 22.2984 31.0367 22.166 30.9101C22.0336 30.7834 21.8772 30.6846 21.7059 30.6194C21.5347 30.5542 21.3522 30.524 21.1691 30.5305C20.986 30.524 20.8034 30.5542 20.6322 30.6194C20.461 30.6846 20.3046 30.7834 20.1722 30.9101C20.0398 31.0367 19.9341 31.1886 19.8613 31.3568C19.7886 31.5249 19.7503 31.7059 19.7487 31.8891C19.75 32.0725 19.7882 32.2537 19.8608 32.4221C19.9334 32.5905 20.0391 32.7426 20.1715 32.8694C20.3039 32.9962 20.4604 33.0953 20.6318 33.1606C20.8031 33.2259 20.9858 33.2562 21.1691 33.2497Z",
			fill: "#CEDBDD"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_590_55746)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M50.9129 49.5928H177.234C178.475 49.5928 179.665 50.0857 180.543 50.9631C181.42 51.8405 181.913 53.0305 181.913 54.2713V77.6642C181.913 78.905 181.42 80.095 180.543 80.9725C179.665 81.8499 178.475 82.3428 177.234 82.3428H50.9129C49.6721 82.3428 48.4821 81.8499 47.6047 80.9725C46.7273 80.095 46.2344 78.905 46.2344 77.6642V54.2713C46.2344 53.0305 46.7273 51.8405 47.6047 50.9631C48.4821 50.0857 49.6721 49.5928 50.9129 49.5928V49.5928Z",
				fill: "#0C5661"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.799 57.0784H86.4702C84.9199 57.0784 83.6631 58.3352 83.6631 59.8855C83.6631 61.4359 84.9199 62.6927 86.4702 62.6927H110.799C112.349 62.6927 113.606 61.4359 113.606 59.8855C113.606 58.3352 112.349 57.0784 110.799 57.0784Z",
			fill: "#779598"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M127.642 69.2427H86.4702C84.9199 69.2427 83.6631 70.4995 83.6631 72.0498C83.6631 73.6002 84.9199 74.857 86.4702 74.857H127.642C129.192 74.857 130.449 73.6002 130.449 72.0498C130.449 70.4995 129.192 69.2427 127.642 69.2427Z",
			fill: "#97B6B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.4982 52.4001H53.7196C51.1357 52.4001 49.041 54.4948 49.041 57.0787V74.8573C49.041 77.4412 51.1357 79.5359 53.7196 79.5359H71.4982C74.0821 79.5359 76.1767 77.4412 76.1767 74.8573V57.0787C76.1767 54.4948 74.0821 52.4001 71.4982 52.4001Z",
			fill: "#1C6974"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M60.4771 69.0376H62.3485L62.3691 68.3171C62.3691 67.3702 62.9661 67.1231 63.8101 66.8555C64.6567 66.6147 65.402 66.1047 65.9331 65.4028C66.4642 64.7008 66.7523 63.8451 66.7539 62.9648C66.7724 62.4274 66.6792 61.892 66.4801 61.3924C66.281 60.8929 65.9803 60.4402 65.5972 60.0628C65.2141 59.6855 64.7568 59.3918 64.2543 59.2004C63.7518 59.0089 63.215 58.9239 62.6779 58.9506C62.1103 58.9382 61.5461 59.0413 61.0195 59.2535C60.493 59.4657 60.015 59.7827 59.6146 60.1852C59.2142 60.5877 58.8997 61.0673 58.6903 61.595C58.4808 62.1227 58.3807 62.6874 58.3961 63.2549H60.3311C60.3238 62.9415 60.379 62.6299 60.4937 62.3382C60.6084 62.0464 60.7801 61.7805 60.9988 61.5561C61.2176 61.3316 61.4789 61.153 61.7676 61.0308C62.0562 60.9086 62.3663 60.8453 62.6798 60.8445C62.9624 60.8281 63.2453 60.8728 63.5092 60.9754C63.773 61.0781 64.0117 61.2364 64.2089 61.4395C64.4062 61.6426 64.5574 61.8858 64.6523 62.1525C64.7472 62.4193 64.7836 62.7033 64.7589 62.9854C64.7465 63.4419 64.5877 63.8824 64.306 64.2419C64.0244 64.6014 63.6347 64.8609 63.1944 64.9822L62.5151 65.2517C61.85 65.412 61.2693 65.8161 60.8881 66.3842C60.5068 66.9522 60.3528 67.6428 60.4565 68.319L60.4771 69.0376ZM61.4034 73.486C61.5867 73.4925 61.7694 73.4622 61.9407 73.3969C62.1121 73.3316 62.2686 73.2326 62.401 73.1057C62.5334 72.9789 62.6391 72.8268 62.7117 72.6584C62.7843 72.4901 62.8225 72.3088 62.8239 72.1255C62.8222 71.9423 62.7839 71.7612 62.7112 71.5931C62.6384 71.4249 62.5327 71.2731 62.4003 71.1464C62.268 71.0198 62.1115 70.9209 61.9403 70.8557C61.7691 70.7905 61.5865 70.7603 61.4034 70.7668C61.2204 70.7603 61.0378 70.7905 60.8666 70.8557C60.6954 70.9209 60.5389 71.0198 60.4065 71.1464C60.2741 71.2731 60.1685 71.4249 60.0957 71.5931C60.023 71.7612 59.9847 71.9423 59.983 72.1255C59.9844 72.3088 60.0226 72.4901 60.0952 72.6584C60.1678 72.8268 60.2735 72.9789 60.4059 73.1057C60.5383 73.2326 60.6948 73.3316 60.8662 73.3969C61.0375 73.4622 61.2202 73.4925 61.4034 73.486Z",
			fill: "#CEDBDD"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_d_590_55746)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.6786 89.8281H137C138.241 89.8281 139.431 90.321 140.308 91.1984C141.186 92.0758 141.679 93.2659 141.679 94.5067V117.9C141.679 119.14 141.186 120.33 140.308 121.208C139.431 122.085 138.241 122.578 137 122.578H10.6786C9.43774 122.578 8.24772 122.085 7.37032 121.208C6.49292 120.33 6 119.14 6 117.9V94.5067C6 93.2659 6.49292 92.0758 7.37032 91.1984C8.24772 90.321 9.43774 89.8281 10.6786 89.8281V89.8281Z",
				fill: "#0C5661"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.5634 97.3147H46.2349C44.6845 97.3147 43.4277 98.5715 43.4277 100.122C43.4277 101.672 44.6845 102.929 46.2349 102.929H70.5634C72.1138 102.929 73.3706 101.672 73.3706 100.122C73.3706 98.5715 72.1138 97.3147 70.5634 97.3147Z",
			fill: "#779598"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.4063 109.479H46.2349C44.6845 109.479 43.4277 110.736 43.4277 112.286C43.4277 113.836 44.6845 115.093 46.2349 115.093H87.4063C88.9567 115.093 90.2135 113.836 90.2135 112.286C90.2135 110.736 88.9567 109.479 87.4063 109.479Z",
			fill: "#97B6B9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.2648 92.6357H13.4862C10.9023 92.6357 8.80762 94.7304 8.80762 97.3143V115.093C8.80762 117.677 10.9023 119.771 13.4862 119.771H31.2648C33.8487 119.771 35.9433 117.677 35.9433 115.093V97.3143C35.9433 94.7304 33.8487 92.6357 31.2648 92.6357Z",
			fill: "#1C6974"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2427 109.273H22.1141L22.1347 108.553C22.1347 107.606 22.7317 107.359 23.5757 107.091C24.4224 106.85 25.1676 106.34 25.6987 105.638C26.2298 104.936 26.5179 104.081 26.5195 103.2C26.538 102.663 26.4448 102.128 26.2457 101.628C26.0466 101.129 25.746 100.676 25.3628 100.298C24.9797 99.9211 24.5224 99.6274 24.0199 99.436C23.5174 99.2445 22.9806 99.1595 22.4435 99.1862C21.8759 99.1738 21.3117 99.2769 20.7852 99.4891C20.2586 99.7013 19.7806 100.018 19.3802 100.421C18.9798 100.823 18.6654 101.303 18.4559 101.831C18.2464 102.358 18.1463 102.923 18.1617 103.49H20.0967C20.0894 103.177 20.1447 102.865 20.2593 102.574C20.374 102.282 20.5457 102.016 20.7644 101.792C20.9832 101.567 21.2445 101.389 21.5332 101.266C21.8218 101.144 22.1319 101.081 22.4454 101.08C22.728 101.064 23.0109 101.108 23.2748 101.211C23.5386 101.314 23.7773 101.472 23.9746 101.675C24.1718 101.878 24.323 102.121 24.4179 102.388C24.5128 102.655 24.5492 102.939 24.5245 103.221C24.5121 103.678 24.3533 104.118 24.0717 104.477C23.79 104.837 23.4003 105.096 22.96 105.218L22.2807 105.487C21.6156 105.648 21.0349 106.052 20.6537 106.62C20.2725 107.188 20.1184 107.878 20.2221 108.555L20.2427 109.273ZM21.1691 113.722C21.3523 113.728 21.535 113.698 21.7064 113.632C21.8777 113.567 22.0342 113.468 22.1666 113.341C22.2991 113.214 22.4047 113.062 22.4773 112.894C22.55 112.726 22.5881 112.544 22.5895 112.361C22.5879 112.178 22.5495 111.997 22.4768 111.829C22.4041 111.661 22.2984 111.509 22.166 111.382C22.0336 111.255 21.8772 111.157 21.7059 111.091C21.5347 111.026 21.3522 110.996 21.1691 111.002C20.986 110.996 20.8034 111.026 20.6322 111.091C20.461 111.157 20.3046 111.255 20.1722 111.382C20.0398 111.509 19.9341 111.661 19.8613 111.829C19.7886 111.997 19.7503 112.178 19.7487 112.361C19.75 112.544 19.7882 112.726 19.8608 112.894C19.9334 113.062 20.0391 113.214 20.1715 113.341C20.3039 113.468 20.4604 113.567 20.6318 113.632C20.8031 113.698 20.9858 113.728 21.1691 113.722Z",
			fill: "#CEDBDD"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_590_55746",
				x: 0,
				y: 6.35693,
				width: 147.679,
				height: 44.75,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_590_55746"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_590_55746",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_590_55746",
				x: 40.2344,
				y: 46.5928,
				width: 147.679,
				height: 44.75,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_590_55746"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_590_55746",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_590_55746",
				x: 0,
				y: 86.8281,
				width: 147.679,
				height: 44.75,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_590_55746"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_590_55746",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgNoDataFoundDark;
